import axios from 'axios';

const API = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    // Don't auto-send cookies; we use Bearer tokens only.
    withCredentials: false,
    timeout: 60000,
});

// Attach the Bearer token only when one exists. Don't send "Bearer null".
// Guard against corrupted tokens (non-printable chars cause INVALID_CHARACTER_ERR in XHR).
API.interceptors.request.use((req) => {
    let token = null;
    try { token = localStorage.getItem('token'); } catch (_) {}
    const isValidToken = token && token !== 'null' && token !== 'undefined' && /^[\x20-\x7E]+$/.test(token);
    if (isValidToken) {
        try {
            req.headers.Authorization = `Bearer ${token}`;
        } catch (_) {
            // Header rejected by browser — token is corrupt, clear it
            try { localStorage.removeItem('token'); } catch (_2) {}
        }
    } else {
        if (token && !isValidToken) {
            // Corrupted token in storage — wipe it so the next request is clean
            try { localStorage.removeItem('token'); } catch (_) {}
        }
        if (req.headers && req.headers.Authorization) {
            delete req.headers.Authorization;
        }
    }
    return req;
});

// On 401, clear local credentials and bounce to login. Stale tokens never linger.
API.interceptors.response.use(
    (res) => res,
    (error) => {
        const status = error?.response?.status;
        if (status === 401) {
            try {
                const accountType = localStorage.getItem('accountType');
                localStorage.removeItem('token');
                localStorage.removeItem('userDetails');
                localStorage.removeItem('menuItems');
                const path = window.location.pathname || '';
                const isOnLogin = path.startsWith('/auth/login') || path.startsWith('/member/login');
                if (!isOnLogin) {
                    window.location.href = accountType === 'member' ? '/member/login' : '/auth/login';
                }
            } catch (_) {
                // ignore — we still reject below
            }
        }
        return Promise.reject(error);
    }
);

export default API;
